import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ArtistService from '../../services/artistService';

class UserOptions extends Component {
    constructor(props, context) {
        super(props, context);
        this.switchActiveProfile = this.switchActiveProfile.bind(this);
        this.getSwitchProfileSection = this.getSwitchProfileSection.bind(this);
        this.logout = this.logout.bind(this);
    }
    componentDidMount() {
    } 

    switchActiveProfile(event, id) {
        event.preventDefault();
        //closeUserDropDown();
        this.props.actions.updateActiveProfile(id);
    }

    getSwitchProfileSection() {
        let listItems = [];
        listItems.push(<li key="switchTitle" className="dropdown-label switch">Switch Active Profile:</li>);
        
        {this.props.user.enabledProfiles.map((profile) => 
            {
                if(profile.ID != this.props.user.activeProfile.ID) {
                    listItems.push(<li key={`switch-${profile.Username}`}><Link key={profile.ID} to={`/${profile.Username}`} className="transition dropdown-profile" onClick={(e) => this.switchActiveProfile(e, profile.ID)}>{`${profile.DisplayName} (${ArtistService.getRoleTypeFriendlyName(profile.RoleType)})`}</Link></li>);
                }
            });
        }                                        
        if(!this.props.sideMenu) {
            listItems.push(<li key="switchSeparator" role="separator" className="divider" />);
        }        
        return listItems;
    }

    closeUserDropDown() {

    }

    logout(event) {
        event.preventDefault();
        this.closeUserDropDown();
        this.props.actions.logout();
    }

    render() {        
        let user = this.props.user;
        return (
            <React.Fragment>
                {
                    this.props.user.activeProfile ?
                        <li>
                            <Link to={`/${this.props.user.activeProfile.Username}`} className="transition dropdown-profile active"><strong>{`${this.props.user.activeProfile.DisplayName} (${ArtistService.getRoleTypeFriendlyName(this.props.user.activeProfile.RoleType)}) ->>`}</strong></Link>
                        </li>
                        :
                        null                                    
                }                                                
                <li><Link to="/Notifications" className="transition" onClick={this.closeUserDropDown}>View Notifications</Link></li>
                <li><Link to="/Account/Settings" className="transition" onClick={this.closeUserDropDown}>Account Settings</Link></li>
                {
                    this.props.user.activeProfile ?
                        <li><Link to="/Profile/Manage" className="transition" onClick={this.closeUserDropDown}>Manage Profile</Link></li>
                    : null
                }                                                
                <li><Link to="/Profile/Create" className="transition" onClick={this.closeUserDropDown}>Add/Remove Profile</Link></li>
                <li role="separator" className="divider" />
                {
                    this.props.user.enabledProfiles && this.props.user.enabledProfiles.length > 1 ?
                        this.getSwitchProfileSection()                                        
                    : 
                    null
                }
                <li><a href="#" className="transition" onClick={this.logout}>Logout</a></li>                                                
            </React.Fragment>
        );
    }
}

UserOptions.propTypes = {
    user: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    sideMenu: PropTypes.bool
};

export default UserOptions;